import React from "react";
import Typography from "@material-ui/core/Typography";
import Snackbar from "@material-ui/core/Snackbar";
import MySnackbarContentWrapper from "../SnackbarContentWrapper/snackbarContentWrapper";

const DeletePageConfirmation = (props) => {
    const {deleteResponseMessage, onDeleteResponseMessageDismiss, selectedPage} = props;

    return (
        <div>
            <Typography variant={"body1"}>
                {`Are you sure you want to delete the selected page (title: ${selectedPage.title}) ?`}
            </Typography>
            {deleteResponseMessage && (
                <Snackbar
                    open={true}
                    autoHideDuration={6000}
                    onClose={onDeleteResponseMessageDismiss}
                >
                    <MySnackbarContentWrapper
                        onClose={onDeleteResponseMessageDismiss}
                        variant="info"
                        message={deleteResponseMessage}
                    />
                </Snackbar>
            )}
        </div>
    )
};

export default DeletePageConfirmation;